import { identity, lowerCase } from 'lodash';
import layeredSoilAttribute from './layeredSoilAttribute';

const percentX = (allLayers: boolean, key: string, ruleId: string) =>
  layeredSoilAttribute({
    allLayers,
    key: `Percent ${key}`,
    ratingCol: {
      displayString: `Percent ${lowerCase(key)}`,
      accessor: 'mapUnitRatingString',
      format: (percent: Nullable<string>) =>
        percent == null ? 'N/A' : `${percent}%`,
      csvFormat: identity,
    },
    ruleId,
    units: `% ${lowerCase(key)}`,
  });

export const PERCENT_CLAY_ALL_LAYERS = percentX(true, 'Clay', '6');
export const PERCENT_CLAY_SURFACE_LAYER = percentX(false, 'Clay', '6');

export const PERCENT_SAND_ALL_LAYERS = percentX(true, 'Sand', '311');
export const PERCENT_SAND_SURFACE_LAYER = percentX(false, 'Sand', '311');

export const PERCENT_SILT_ALL_LAYERS = percentX(true, 'Silt', '312');
export const PERCENT_SILT_SURFACE_LAYER = percentX(false, 'Silt', '312');
